<template>
    <div class="space-y-2">
        <p class="font-medium text-xs text-gray-500">Enter desired recurring payment amount below:</p>
        <div class="flex items-center rounded-lg border-2" :class="{
            'border-red-400': ! validAmount,
            'bg-gray-100': disabled,
        }">
            <span class="flex-initial items-center text-sm font-bold text-black pl-3 pr-2" :class="{
                'text-red-400': ! validAmount
            }">
                $
            <input
                v-model="value"
                type="text"
                name="amount"
                id="amount"
                placeholder="Payment Amount"
                class="border-0 focus:border-0 focus:ring-0 pl-0 py-2.5 text-sm font-medium text-black"
                @input="$emit('input', Number($event.target.value))"
                :min="min"
                :max="max"
                :disabled="disabled"
                :class="{
                    'text-red-400': ! validAmount,
                    'bg-gray-100': disabled,
                }">
            </span>
        </div>
        <p v-if="! validAmount" class="font-medium text-xs text-red-400">Min {{ min | money }}, Max {{ max | money }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            amount: {},
            min: {},
            max: {},
            disabled: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            validAmount() {
                return this.value >= this.min && this.value <= this.max;
            }
        },

        data() {
            return {
                value: null
            };
        },

        watch: {
            amount(amount) {
                this.value = amount;
            }
        },

        mounted() {
            this.value = this.amount;
        }
    }
</script>
